<!--Accounts-->

<dx-data-grid
  class="h-100"
  height="100%"
  (onToolbarPreparing)="onGridToolbarPreparing($event)"
  [dataSource]="accounts"
  [remoteOperations]="false"
  [allowColumnReordering]="true"
  [rowAlternationEnabled]="true"
  [allowColumnResizing]="true"
  noDataText="{{ 'keine Accounts vorhanden' | translate }}"
  [showBorders]="true"
>
  <div *dxTemplate="let toolbaritem of 'refreshButtonTemplate'">
    <dx-button
      stylingMode="text"
      type="default"
      text="{{ 'Aktualisieren' | translate }}"
      (onClick)="reloadAccounts()"
      hint="{{ 'Aktualisieren' | translate }}"
    ></dx-button>
  </div>
  <dxo-group-panel [visible]="false"></dxo-group-panel>
  <dxo-paging [pageSize]="1000"></dxo-paging>
  <dxo-search-panel
    [visible]="true"
    [highlightCaseSensitive]="true"
    placeholder="{{ 'Accounts suchen' | translate }}"
    class="treeSearch"
  ></dxo-search-panel>

  <dxo-filter-row [visible]="true"></dxo-filter-row>
  <dxo-header-filter [visible]="true"></dxo-header-filter>

  <dxo-state-storing [enabled]="true" type="localStorage" storageKey="AdminAccountsStateNewUIV1"></dxo-state-storing>

  <dxi-column dataField="name" caption="{{ 'Name' | translate }}" dataType="string" [allowFiltering]="false"></dxi-column>
  <dxi-column
    dataField="licenseId"
    caption="{{ 'NextPim Version' | translate }}"
    dataType="string"
    [lookup]="{ dataSource: licenses, valueExpr: 'id', displayExpr: 'identifier' }"
  ></dxi-column>
  <dxi-column
    dataField="accountType"
    caption="{{ 'Hub-Kennzeichen' | translate }}"
    dataType="string"
    [lookup]="{ dataSource: accountTypes, valueExpr: 'value', displayExpr: 'translated' }"
  ></dxi-column>
</dx-data-grid>
